<script>
    import { createEventDispatcher } from 'svelte'
    import BigIcon from '../../components/Icons/BigIcon.svelte'
    import SidepanelButton from '../../components/SidepanelLink/SidepanelButton.svelte'
    import SearchQuery from '../../components/SearchQuery/SearchQuery.svelte'
    import PeriodSelector from '../../components/PeriodSelector/PeriodSelector.svelte'
    import SidepanelSelect from '../../components/SidepanelFields/SidepanelSelect.svelte'
    import MonthChanger from '../../components/SvelteFullCalendar/MonthChanger/MonthChanger.svelte'
    import TooltipTrigger from '../../components/Tooltip/TooltipTrigger.svelte'

    export let viewType = 'list'
    export let sector 
    export let start 
    export let end
    export let calendarOpts = {}
    export let contentHeight = 0
    

    let viewTypes = [
            {
                text: 'Vedi come lista',
                value: 'list'
            },
            {
                text: 'Vedi come calendario',
                value: 'calendar'
            }
        ],
        calViews = [
            {
                text: 'Mese',
                value: 'dayGridMonth'
            },
            {
                text: 'Settimana',
                value: 'timeGridWeek'
            },
            {
                text: 'Giorno',
                value: 'dayGrid'
            }
        ]
    
    
    const dispatch = createEventDispatcher ();
    
    const onViewTypeChange = (event) => {
        viewType = event.detail;
        dispatch ('view-change', viewType)
    }

    const onCalendarViewChange = (event) => {
        dispatch ('calendar-view-change', event.detail)
    }
</script>

<style>
    .SidepanelContent {
        padding: 25px 20px 20px 20px;
    }
    .SidepanelContent .icon-holder {
        text-align: center;
        margin-bottom: 10px;
    }
    .SidepanelContent .meta {
        text-align: center;
        margin-bottom: 20px;
    }
    .SidepanelContent .meta .label {
        font-size: 18px;
        font-weight: 600;
    }
    .SidepanelContent .meta .text {
        font-size: 13px;
        color: var(--text-secondary);
        line-height: 14px;
    }
    .SidepanelContent .time-range {
        margin-top: 10px;
    }
    .SidepanelContent .search {
        margin-top: 10px;
    }

    .SidepanelContent .view-type {
        margin-top: 10px;
    }

    @media(max-width: 640px) {
        .view-type { display: none }
    }
</style>

<div class="SidepanelContent" bind:clientHeight={contentHeight}>
    <div class="icon-holder">
        <BigIcon icon="fad fa-history"  />
    </div>
    {#if sector}
        <div class="meta">
            <div class="label">Programmi {sector.name}</div>
        </div>

        <div class="links">
            <SidepanelButton on:click={e => dispatch ('create')} >
                Nuovo Programma
            </SidepanelButton>
            <!-- <SideLink url="/app/clients" label="Lista clienti" />
            <SideLink url="/app/clients/{model.id}/logs" label="Timeline" /> -->
        </div>
        <div class="view-type">
            <SidepanelSelect items={viewTypes} value={viewType} on:select={onViewTypeChange} />
        </div>

        {#if viewType === 'list'}
            <div class="search">
                <SearchQuery on:search />
            </div>
            <div class="time-range">
                <PeriodSelector {start} {end} on:period-change />
            </div>
        {:else if viewType === 'calendar'}
            <div class="time-range">
                <SidepanelSelect items={calViews} value="dayGridMonth" on:select={onCalendarViewChange} />
            </div>
            <div class="time-range">
                <MonthChanger value={calendarOpts.currentMonth} on:month-change />
            </div>
        {/if}
    {/if}
</div>